<div class="left-nav-container">
  @if (rights && !rights?.includes('HideHomeButtonInMenu')) {
    <button
      type="button"
      id="home-button"
      mat-button
      class="main-button"
      [disabled]="disableButtons"
      (click)="goToHome()"
    >
      <mat-icon>home</mat-icon>Home
    </button>
  }

  @if (!searchPage) {
    @if (
      modStatusSvc.apps() &&
      (modStatusSvc.apps().includes('pp') ||
        currentApp === 'rb' ||
        modStatusSvc.apps().includes('clientinfo'))
    ) {
      <button
        type="button"
        id="client-info"
        mat-button
        class="main-button client-info"
        [ngClass]="{
          active: currentApp.toLowerCase() === 'rb',
          'app-complete': appStatuses.complete.includes('clientinfo'),
          'app-inprogress': appStatuses.inProgress.includes('clientinfo'),
        }"
        [disabled]="disableButtons"
        (click)="changeApp('rb')"
      >
        <mat-icon>account_box</mat-icon>Client Information
        @if (currentApp !== 'summary') {
          <div class="indicator">
            <mat-icon class="error">priority_high</mat-icon>
            <mat-icon class="complete">check</mat-icon>
          </div>
        }
      </button>

      @if (
        currentApp === 'rb' && stepsList.length > 1 && !unfFlowSvc.getloading()
      ) {
        <div class="app-steps" [ngClass]="{ open: stepsList.length > 1 }">
          @for (stp of stepsList; track stp.label; let idx = $index) {
            <button
              type="button"
              mat-button
              [hidden]="stp.hidden"
              [class]="checkAppStep(idx)"
              [disabled]="disableButtons"
              (click)="changeTab(stp, idx)"
            >
              <span class="label-container">
                {{ stp.label }}
              </span>
              <div class="indicator">
                <mat-icon class="error">priority_high</mat-icon>
                <mat-icon class="complete">check</mat-icon>
              </div>
            </button>
          }
        </div>
      }
    }

    @if (
      (modStatusSvc.apps() && modStatusSvc.apps().includes('pp') && profile) ||
      currentApp === 'pp'
    ) {
      <button
        type="button"
        id="product-profiler"
        mat-button
        class="main-button"
        [ngClass]="{
          active: currentApp.toLowerCase() === 'pp',
          'app-complete': appStatuses.complete.includes('pp'),
          'app-inprogress': appStatuses.inProgress.includes('pp'),
        }"
        [disabled]="disableButtons"
        (click)="changeApp('pp')"
      >
        <mat-icon class="app-icon" svgIcon="pp_icon" /> Product Profiler<div
          class="indicator"
        ></div>
      </button>
    }
    @if (
      currentApp === 'pp' && stepsList.length > 1 && !unfFlowSvc.getloading()
    ) {
      <div class="app-steps pp" [ngClass]="{ open: stepsList.length > 1 }">
        @for (stp of stepsList; track stp.label; let idx = $index) {
          <button
            type="button"
            mat-button
            [hidden]="stp.hidden"
            [class]="checkAppStep(idx)"
            [disabled]="disableButtons"
            (click)="changeTab(stp, idx)"
          >
            <span class="label-container">
              {{ stp.label }}
            </span>
            <div class="indicator">
              <mat-icon class="error">priority_high</mat-icon>
              <mat-icon class="complete">check</mat-icon>
            </div>
          </button>
        }
        <button
          type="button"
          mat-button
          class="results-button"
          [ngClass]="{
            current: currentTab === 'results' && currentApp === 'pp',
          }"
          [disabled]="disableButtons"
          (click)="changeToPage('pp', 'results')"
        >
          Results
          <div class="indicator">
            <mat-icon class="error">priority_high</mat-icon>
            <mat-icon class="complete">check</mat-icon>
          </div>
        </button>
      </div>
    }

    @if (
      (modStatusSvc.apps() && modStatusSvc.apps().includes('aw')) ||
      currentApp === 'aw'
    ) {
      <button
        type="button"
        id="annuity-wizard"
        mat-button
        class="main-button"
        [ngClass]="{
          active: currentApp.toLowerCase() === 'aw',
          'app-complete': appStatuses.complete?.includes('aw'),
          'app-inprogress': appStatuses.inProgress?.includes('aw'),
        }"
        [disabled]="disableButtons"
        (click)="changeApp('aw')"
      >
        <mat-icon class="app-icon" svgIcon="aw_icon" /> Annuity Wizard<div
          class="indicator"
        ></div>
      </button>
    }
    @if (
      currentApp === 'aw' && stepsList.length >= 1 && !unfFlowSvc.getloading()
    ) {
      <div class="app-steps aw" [ngClass]="{ open: stepsList.length >= 1 }">
        @for (stp of stepsList; track stp.label; let idx = $index) {
          <button
            class="{{ checkAppStep(idx) }}"
            type="button"
            mat-button
            [hidden]="stp.hidden"
            [disabled]="disableButtons"
            (click)="changeTab(stp, idx)"
          >
            <span class="label-container">
              {{ stp.label }}
            </span>
            <div class="indicator">
              <mat-icon class="error">priority_high</mat-icon>
              <mat-icon class="complete">check</mat-icon>
            </div>
          </button>
        }
        @if (modStatusSvc.hasAwComparisonPage()) {
          <button
            type="button"
            mat-button
            [ngClass]="{
              current: currentTab === 'compare-results' && currentApp === 'aw',
              visited: currentTab === 'results' && currentApp === 'aw',
            }"
            [disabled]="disableButtons"
            (click)="changeToPage('aw', 'compare-results')"
          >
            Income Comparison
            <div class="indicator">
              <mat-icon class="error">priority_high</mat-icon>
              <mat-icon class="complete">check</mat-icon>
            </div>
          </button>
        }
        <button
          type="button"
          mat-button
          class="results-button"
          [ngClass]="{
            current: currentTab === 'results' && currentApp === 'aw',
          }"
          [disabled]="disableButtons"
          (click)="changeToPage('aw', 'results')"
        >
          Results
          <div class="indicator">
            <mat-icon class="error">priority_high</mat-icon>
            <mat-icon class="complete">check</mat-icon>
          </div>
        </button>
      </div>
    }
    @if (
      (modStatusSvc.apps() && modStatusSvc.apps().includes('iw')) ||
      currentApp === 'iw'
    ) {
      <button
        type="button"
        id="investment-wizard"
        mat-button
        class="main-button"
        [ngClass]="{
          active: currentApp.toLowerCase() === 'iw',
          'app-complete': appStatuses.complete.includes('iw'),
          'app-inprogress': appStatuses.inProgress.includes('iw'),
        }"
        [disabled]="disableButtons"
        (click)="changeApp('iw')"
      >
        <mat-icon class="app-icon" svgIcon="iw_icon" /> Investment Wizard<div
          class="indicator"
        ></div>
      </button>
    }
    @if (
      currentApp === 'iw' && stepsList.length > 1 && !unfFlowSvc.getloading()
    ) {
      <div class="app-steps iw" [ngClass]="{ open: stepsList.length > 1 }">
        @for (stp of stepsList; track stp.label; let idx = $index) {
          <button
            class="{{ checkAppStep(idx) }}"
            type="button"
            mat-button
            [hidden]="stp.hidden"
            [disabled]="disableButtons"
            (click)="changeTab(stp, idx)"
          >
            <span class="label-container">
              {{ stp.label }}
            </span>
            <div class="indicator">
              <mat-icon class="error">priority_high</mat-icon>
              <mat-icon class="complete">check</mat-icon>
            </div>
          </button>
        }
        @if (!iwValidateTrack) {
          <button
            type="button"
            mat-button
            class="program-selection"
            [ngClass]="{
              visited:
                currentTab === 'advisory' ||
                currentTab === 'investment-model' ||
                currentTab === 'results' ||
                currentTab === 'validate' ||
                currentTab === 'fund-allocations',
              current:
                currentTab === 'program-selection' && currentApp === 'iw',
            }"
            [disabled]="disableButtons"
            (click)="changeToPage('iw', 'program-selection')"
          >
            Program Selection
            <div class="indicator">
              <mat-icon class="error">priority_high</mat-icon>
              <mat-icon class="complete">check</mat-icon>
            </div>
          </button>
        }
        @if (
          !iwValidateTrack && iwProg && iwProg !== 'Advisory' && selectedIWProg
        ) {
          <button
            type="button"
            mat-button
            class="investment-model"
            [ngClass]="{
              visited:
                currentTab === 'advisory' ||
                currentTab === 'results' ||
                currentTab === 'validate' ||
                currentTab === 'fund-allocations',
              current: currentTab === 'investment-model' && currentApp === 'iw',
            }"
            [disabled]="disableButtons"
            (click)="changeToPage('iw', 'investment-model')"
          >
            Investment Model
            <div class="indicator">
              <mat-icon class="error">priority_high</mat-icon>
              <mat-icon class="complete">check</mat-icon>
            </div>
          </button>
        }
        @if (
          !iwValidateTrack && iwProg && iwProg !== 'Advisory' && selectedIWProg
        ) {
          <button
            class="fund-allocation"
            type="button"
            mat-button
            [ngClass]="{
              current: currentTab === 'fund-allocations' && currentApp === 'iw',
              'error step-button':
                checkFundAllocation() && currentTab !== 'fund-allocations',
              visited:
                !checkFundAllocation() &&
                (currentTab === 'advisory' ||
                  currentTab === 'results' ||
                  currentTab === 'validate'),
            }"
            [disabled]="disableButtons"
            (click)="changeToPage('iw', 'fund-allocations')"
          >
            Fund Allocation
            <div class="indicator">
              <mat-icon class="error">priority_high</mat-icon>
              <mat-icon class="complete">check</mat-icon>
            </div>
          </button>
        }
        <button
          type="button"
          class="results-button"
          mat-button
          [ngClass]="{
            visited: currentTab === 'results',
            current: currentTab === 'validate' && currentApp === 'iw',
          }"
          [disabled]="disableButtons"
          (click)="changeToPage('iw', 'validate')"
        >
          Results
          <div class="indicator">
            <mat-icon class="error">priority_high</mat-icon>
            <mat-icon class="complete">check</mat-icon>
          </div>
        </button>
      </div>
    }
    @if (
      (modStatusSvc.apps() && modStatusSvc.apps().includes('li')) ||
      currentApp === 'li'
    ) {
      <button
        type="button"
        id="life-wizard"
        mat-button
        class="main-button"
        [ngClass]="{
          active: currentApp.toLowerCase() === 'li',
          'app-complete': appStatuses.complete.includes('li'),
          'app-inprogress': appStatuses.inProgress.includes('li'),
        }"
        [disabled]="disableButtons"
        (click)="changeApp('li')"
      >
        <mat-icon class="app-icon" svgIcon="lw_icon" /> Life Insurance
        Wizard<div class="indicator"></div>
      </button>
    }
    @if (
      currentApp === 'li' && stepsList.length >= 1 && !unfFlowSvc.getloading()
    ) {
      <div class="app-steps li" [ngClass]="{ open: stepsList.length >= 1 }">
        @for (stp of stepsList; track stp.label; let idx = $index) {
          <button
            class="{{ checkAppStep(idx) }}"
            type="button"
            mat-button
            [hidden]="stp.hidden"
            [disabled]="disableButtons"
            (click)="changeTab(stp, idx)"
          >
            <span class="label-container">
              {{ stp.label }}
            </span>
            <div class="indicator">
              <mat-icon class="error">priority_high</mat-icon>
              <mat-icon class="complete">check</mat-icon>
            </div>
          </button>
        }
        @if (!liValidateTrack) {
          <button
            type="button"
            mat-button
            [ngClass]="{
              visited: currentTab === 'compare' || currentTab === 'products',
              current: currentTab === 'results' && currentApp === 'li',
            }"
            [disabled]="disableButtons"
            (click)="changeToPage('li', 'results')"
          >
            Life Insurance Review
            <div class="indicator">
              <mat-icon class="error">priority_high</mat-icon>
              <mat-icon class="complete">check</mat-icon>
            </div>
          </button>
        }
        @if (!liValidateTrack) {
          <button
            type="button"
            mat-button
            [ngClass]="{
              visited: currentTab === 'products',
              current: currentTab === 'compare' && currentApp === 'li',
            }"
            [disabled]="disableButtons"
            (click)="changeToPage('li', 'compare')"
          >
            Compare Scenarios
            <div class="indicator">
              <mat-icon class="error">priority_high</mat-icon>
              <mat-icon class="complete">check</mat-icon>
            </div>
          </button>
        }
        @if (!liValidateTrack) {
          <button
            type="button"
            class="product-result"
            mat-button
            [ngClass]="{
              visited: visitedSteps?.includes('products'),
              current: currentTab === 'products' && currentApp === 'li',
            }"
            [disabled]="disableButtons"
            (click)="changeToPage('li', 'products')"
          >
            Results
            <div class="indicator">
              <mat-icon class="error">priority_high</mat-icon>
              <mat-icon class="complete">check</mat-icon>
            </div>
          </button>
        }
        @if (liValidateTrack) {
          <button
            type="button"
            class="validate-result"
            mat-button
            [ngClass]="{
              visited: visitedSteps?.includes('validate'),
              current: currentTab === 'validate' && currentApp === 'li',
            }"
            [disabled]="disableButtons"
            (click)="changeToPage('li', 'validate')"
          >
            Results
            <div class="indicator">
              <mat-icon class="error">priority_high</mat-icon>
              <mat-icon class="complete">check</mat-icon>
            </div>
          </button>
        }
      </div>
    }

    @if (profile && modStatusSvc.showCaseSummary()) {
      <button
        type="button"
        mat-button
        id="case-summary"
        class="main-button"
        [ngClass]="{ active: currentApp === 'summary' }"
        [disabled]="disableButtons"
        (click)="changeApp('summary')"
      >
        <mat-icon>list</mat-icon>Case Summary<div class="indicator"></div>
      </button>
    }
  }
</div>

<div class="status-container"></div>
